import api from "./api";

// Get notification preferences for the current user
export const getNotificationPreferences = (userType) => {
  return api.get(`/notifications/preferences`, {
    params: { userType }
  });
};

// Update notification preferences
export const updateNotificationPreferences = (preference) => {
  return api.put(`/notifications/preferences`, preference);
};

// Toggle email notifications
export const toggleEmailNotifications = (userType, enabled) => {
  return api.put(`/notifications/preferences/email-toggle`, null, {
    params: { userType, enabled }
  });
};

const notificationService = {
  getNotificationPreferences,
  updateNotificationPreferences,
  toggleEmailNotifications
};

export default notificationService;
